import { render, staticRenderFns } from "./set_store.vue?vue&type=template&id=08195d90&scoped=true"
import script from "./set_store.vue?vue&type=script&lang=js"
export * from "./set_store.vue?vue&type=script&lang=js"
import style0 from "./set_store.vue?vue&type=style&index=0&id=08195d90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08195d90",
  null
  
)

export default component.exports